import * as Yup from 'yup';
import { selectEnums, selectIsFetchingEnums } from '../../ducks/entities';
import { useEffect, useState } from 'react';
import { FiAlertTriangle } from 'react-icons/fi';
import { Form } from 'react-bootstrap';
import StudioSelect from '../StudioSelect/StudioSelect';
import YesNoButton from '../YesNoButton/YesNoButton';
import cn from 'classnames';
import { countries } from '../../utils/constants';
import { createStudioOptions } from '../../utils/generic';
import iconBuilding from '../../assets/images/ubisoft-playtest-icon-building-black.webp';
import messages from './messages';
import siteMessages from '../../pages/root/siteMessages';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

interface Props {
  isInterested: boolean | null;
  values: any;
  errors: any;
  setFieldValue: any;
  updateSchema: (value: any) => void;
  withHeader?: boolean;
}

const StudioTesting = ({
  isInterested,
  values,
  errors,
  setFieldValue,
  updateSchema,
  withHeader = true
}: Props) => {
  const intl = useIntl();
  const [interested, setInterested] = useState(isInterested);
  const [studioOptions, setStudioOptions] = useState<any>();
  const enums = useSelector(selectEnums);
  const isFetchingEnums = useSelector(selectIsFetchingEnums);

  useEffect(() => {
    if (!isFetchingEnums && enums?.studios) {
      const studioConvert = enums.studios
        .filter((studio: any) => studio.supportsInPersonTesting)
        .map((studio: any) => {
          const country = countries.find((c) => c.id === studio.countryId);
          const countryMessage = country
            ? messages[`countries.${country.name}` as keyof typeof messages]
            : undefined;

          return {
            id: studio.id,
            name: studio.name,
            country: {
              id: studio.countryId,
              name: countryMessage ? intl.formatMessage(countryMessage) : ''
            }
          };
        });
      const options = createStudioOptions(studioConvert);
      setStudioOptions(options);
    }
  }, [enums?.studios]);

  useEffect(() => {
    const studioTestingSchema = {
      studioId: Yup.string().required(
        intl.formatMessage({ ...siteMessages.FIELD_REQUIRED })
      )
    };
    updateSchema(studioTestingSchema);
  }, []);

  return (
    <div className="studio-testing">
      {withHeader && (
        <div className="header">
          <img src={iconBuilding} alt="" className="mt-n1" />
          <h3>{intl.formatMessage({ ...messages.headerStudioTesting })}</h3>
        </div>
      )}
      <div className="content">
        <YesNoButton
          id="candidateStudio"
          name="studioTesting"
          label={intl.formatMessage({ ...messages.studioTesting })}
          value={interested}
          onChange={(value: boolean) => {
            setInterested(value);
            setFieldValue('studioTesting', value);
          }}
        />
        {interested && (
          <Form.Group controlId="studioId" className="w-100">
            <Form.Label className="fw-bold">
              {intl.formatMessage({ ...messages.studio })}
            </Form.Label>
            <StudioSelect
              controlId="studioId"
              className={cn(
                'nemo-select',
                errors?.studioId || typeof errors == 'string'
                  ? 'invalid-select'
                  : ''
              )}
              options={studioOptions}
              value={values.studioId}
              onChange={(value: any) =>
                setFieldValue('candidateStudio.studioId', value)
              }
              placeholder={intl.formatMessage({
                ...siteMessages.selectSinglePlaceholder
              })}
            />
            {errors?.studioId || typeof errors == 'string' ? (
              <div className="feedback">
                <FiAlertTriangle className="mb-1 me-1" />
                {errors?.studioId ? errors.studioId : errors}
              </div>
            ) : (
              <></>
            )}
          </Form.Group>
        )}
      </div>
    </div>
  );
};

export default StudioTesting;
